import styled from "styled-components";

export const SearchButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-self: end;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.7rem;
  font-weight: 700;
  height: 4.5rem;
  justify-content: center;
  margin-top: 2rem;
  width: 16rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.primaryBlue + theme.transparencies.p20};
    cursor: default;
  }

  @media (max-width: 1600px) {
    width: 76px;

    span {
      display: none;
    }
    &:after {
      content: ">";
    }
  }
`;
interface ISearchBar {
  flexStart?: any;
  hmargin?: any;
  dateHeight?: string;
  dateWidth?: string;
}
export const SearchBar = styled.div<ISearchBar>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  justify-content: ${(props) =>
    props.flexStart ? "flex-start" : "space-between"};
  margin-bottom: 3rem;
  margin-inline: ${(props) => (props.hmargin ? "0" : "2rem")};

  .search-button--container {
    align-self: end;
  }

  & > div {
    margin: 1rem 0rem;
  }

  h3 {
    ${(props) => `
      color: ${props.theme.colors.primaryBlue};
    `}
    margin-left: 0.2rem;
    font-size: 1.4rem;
    font-weight: 700;
  }

  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: ${(props) => (props.dateHeight ? props.dateHeight : "100%")};
    padding-right: 1rem;
    width: ${(props) => (props.dateWidth ? props.dateWidth : "100%")};
  }

  .dates--container {
    display: flex;
    flex-wrap: wrap;
  }

  .dates--secondary-container {
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    p {
      width: 3rem;
    }
  }

  .date-picker--container {
    margin: 0 1rem;
  }
  .react-date-picker__wrapper {
    border: none;
  }

  .clickable-element {
    cursor: pointer;
  }

  .search-button--container {
    display: flex;
    gap: 2rem;
  }
`;
